import { FC } from 'react';
import styles from './Stack.module.scss';

const Stack: FC = ({ children }) => (
	<div className={styles.root}>{children}</div>
);

export default Stack;
